<template>
  <div class="track-container" ref="componentFocusTarget">
    <div class="track-container__inner track-container--details">
      <h2>Tell us about yourself?</h2>
      
      <label for="age">How old are you?</label>
      <input v-model="age"  id="age" type="number" min="0" max="100" @change="checkAge">

      <label for="gender">Filter by</label>
      <div class="gender-option" role="radiogroup" aria-label="Filter by">     
        
        <div class="gender-option__position">
          <div class="gender-option__item">
            <input type="radio" id="m" value="M" v-model="gender">
            <span class="gender-option__value">
              <img v-if="gender === 'M'" src="../assets/male_icon_white.svg">
              <img v-else src="../assets/male_icon.svg">
            </span>
          </div>
          <label for="m">Males</label>
        </div>

        <div class="gender-option__position">
          <div class="gender-option__item">
            <input type="radio" id="f" value="F" v-model="gender">
            <span class="gender-option__value">
              <img v-if="gender === 'F'" src="../assets/female_icon_white.svg">
              <img v-else src="../assets/female_icon.svg">
            </span>
          </div>
          <label for="f">Females</label>
        </div>

        <div class="gender-option__position">
          <div class="gender-option__item">
            <input type="radio" id="x" value="X" v-model="gender">
            <span class="gender-option__value">
              <img v-if="gender === 'X'" src="../assets/both_icon_white.svg">
              <img v-else src="../assets/both_icon.svg">
            </span>
          </div>
          <label for="x">Everyone</label>
        </div>


      </div>

      <!-- <label for="postcode">Which State/Territory do you live in?</label>
      <span class="select-wrapper">
        <select id="postcode" v-model="postcode" class="select-superwide">
          <option v-for="location in getPostcodeList" :key="location.id" :value="location.value">
            {{ location.text }}
          </option>
        </select>
      </span>
      -->

      <h2>Tell us about your super</h2>
      
      <label for="scheme">Scheme</label>
      <span class="select-wrapper">
        <select id="scheme" v-model="scheme" >
          <option v-for="schemename in getSchemeList" :key="schemename.id" :value="schemename.value">
            {{ schemename.text }}
          </option>
        </select>
      </span>

      <label for="pre-tax" v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
        <span class="pre-tax">Pre Tax Contributions</span>
        <span v-on:click.self.prevent class="infoIcon" content="A contribution that is made before any taxes are paid on the amount." 
          v-tippy="{ maxWidth: 300, placement: 'top', arrow: true }"
        >?</span>
      </label>
      <span class="pre-tax-container" v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
        <input v-model="preTaxContributions" id="pre-tax" type="number" min="0">
        <span class="pre-tax-container__value">{{preTaxContributions ? currencyString(preTaxContributions) : '$0'}}</span>
      </span>

      <label for="post-tax" v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
        <span class="post-tax">Post Tax Contributions</span>
        <span v-on:click.self.prevent class="infoIcon" content="A contribution that is made from your after-tax income, and does not incur any further tax." 
          v-tippy="{ maxWidth: 300, placement: 'top', arrow: true }"
        >?</span>
      </label>
      <span class="post-tax-container" v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
        <input v-model="postTaxContributions" id="post-tax" type="number" min="0">
        <span class="post-tax-container__value">{{postTaxContributions ? currencyString(postTaxContributions) : '$0'}}</span>
      </span>

      <label for="super-balance">
        <span class="super-balance">Your balance</span>
        <span v-on:click.self.prevent v-if="scheme === 'PSS'" class="infoIcon" content="This amount includes your total employer and member contributions." 
          v-tippy="{ maxWidth: 300, placement: 'top', arrow: true }"
        >?</span>
        <span v-on:click.self.prevent v-if="scheme === 'MSBS'" class="infoIcon" content="This amount includes your total employer, member and ancillary contributions." 
          v-tippy="{ maxWidth: 300, placement: 'top', arrow: true }"
        >?</span>
      </label>
      
      <span class="fund-balance-container">
        <input v-model="fundBalance" id="super-balance" type="number" min="0">
        <span class="fund-balance-container__value">{{fundBalance ? currencyString(fundBalance) : '$0'}}</span>
      </span>      

      <p></p>
      <router-link to="/results" class="button" :class="{disabled: !filledInInputs}">Show me</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Details',
  computed: {
    ...mapGetters([
      'getAge', 
      'getGender', 
      'getFundBalance', 
      'getPreTaxContributions', 
      'getPostTaxContributions', 
      'getScheme', 
      'getSchemeList', 
      'getPostcode', 
      'getPostcodeList'
    ]),
    age: {
      get () {
        return this.getAge
      },
      set (value) {
        this.setAge(value)
      }
    },
    gender: {
      get() {
        return this.getGender;
      },
      set(value) {
        this.setGender(value)
      }
    },
    fundBalance: {
      get() {
        return this.getFundBalance;
      },
      set(value) {
        this.setFundBalance(value)
      }
    },
    preTaxContributions: {
      get() {
        return this.getPreTaxContributions;
      },
      set(value) {
        this.setPreTaxContributions(value)
      }
    },
    postTaxContributions: {
      get() {
        return this.getPostTaxContributions;
      },
      set(value) {
        this.setPostTaxContributions(value)
      }
    },
    scheme: {
      get() {
        return this.getScheme;
      },
      set(value) {
        this.setScheme(value)
      },
    },
    postcode: {
      get() {
        return this.getPostcode;
      },
      set(value) {
        this.setPostcode(value)
      }
    },
    filledInInputs() {
      return this.getAge > 0 && this.getFundBalance >= 0 && this.getScheme != '' && this.getGender != ''
    }
  },
  methods: {
    ...mapMutations([
      'setAge', 
      'setGender', 
      'setFundBalance', 
      'setPreTaxContributions', 
      'setPostTaxContributions', 
      'setScheme', 
      'setPostcode'
    ]),
    currencyString(val) {
      return '$' + parseInt(val).toLocaleString();
    },
    checkAge() {
      this.age = this.age < 0 ? 0 : this.age; 
      this.age = this.age > 100 ? 100 : this.age;
    },
    track () {
      this.$ga.page('/details')
    }
  }
}
</script>